import CoreUtils from '../utils/CoreUtils';
import NumberUtils from '../utils/NumberUtils';

import EnergyValue from './EnergyValue';

const delimiter = ';';
const delimiterCharCode = delimiter.charCodeAt(0);
const minusSignCharCode = 0x002D;
const zeroCharCode = 0x0030;
const nineCharCode = 0x0039;

export default class EnergyValueInputUtils {
  static convertToEditorString(energyValue, locale, showZeroValues) {
    if (CoreUtils.isUndefinedOrNull(energyValue) || !(energyValue instanceof EnergyValue))
      return '';

    var zeroValue = showZeroValues
      ? 0
      : null;

    var editorString = '';
    for (var index = 0; index < energyValue.values.length; index += 1) {
      if (index > 0)
        editorString += delimiter;

      var value = !EnergyValueInputUtils.isZeroValue(energyValue.values[index])
        ? energyValue.values[index]
        : zeroValue;

      editorString += EnergyValueInputUtils.convertValueToDisplayString(value, locale);
    }

    return editorString;
  }

  static convertValueToDisplayString(value, locale) {
    return CoreUtils.isDefinedAndNotNull(value)
      ? NumberUtils.formatNumber(value, locale)
      : '';
  }

  static generateEditorString(data, target) {
    return target.value.substring(0, target.selectionStart)
      + (data ?? '')
      + target.value.substring(target.selectionEnd);
  }

  static tryParseEditorString(editorString, subhourlyResolution) {
    if (CoreUtils.isUndefinedOrNull(editorString) || typeof editorString !== 'string')
      return null;

    var values = [];

    var parseState = {
      isNegative: false,
      isParsingNumber: false,
      number: ''
    }

    for (var index = 0; index < editorString.length; index += 1) {
      var charCode = editorString.charCodeAt(index);

      if (charCode === minusSignCharCode) {
        if (parseState.isParsingNumber)
          return null;

        parseState.isNegative = true;
        parseState.isParsingNumber = true;
      } else if (charCode === delimiterCharCode) {
        EnergyValueInputUtils.commitParseState(values, parseState);
      } else if (charCode >= zeroCharCode && charCode <= nineCharCode) {
        parseState.number += String.fromCharCode(charCode);
        parseState.isParsingNumber = true;
      } else {
        return null;
      }
    }

    EnergyValueInputUtils.commitParseState(values, parseState);

    if (values.length > subhourlyResolution)
      return null;

    return new EnergyValue(values);
  }

  static commitParseState(values, parseState) {
    var value = parseState.number.length > 0
      ? parseInt(parseState.number, 10)
      : 0;

    if (parseState.isNegative)
      value *= -1;

    if (EnergyValueInputUtils.isZeroValue(value))
      value = 0;

    values.push(value);

    parseState.isNegative = false;
    parseState.isParsingNumber = false;
    parseState.number = '';
  }

  static isZeroValue(value) {
    return value === null || value === 0;
  }
}